import React, { useCallback, useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import AdminNavigation from "../AdminNavigation";
import Select from "../../../forms/Select";
import { validateField } from "../../../pages/functions";
import { COUNTRIES, REF_DATA } from "../../../constants";
import { addNotification as notify } from "reapop";
import connect from "react-redux/es/connect/connect";
import { api } from "../../index.api";
import ReactSelect from "react-select";
import EditProductTable from "./EditProductTable";
import "./prod_styles.css";
import { api_v2 } from "../../NewIndex.api";
import { getApplicationRegex } from "../../plugins/utils";
import { withRouter } from "react-router-dom";

const EditProduct = (props) => {
  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };
  const editProductFields = {
    affiliate: {
      name: "Affiliate",
      value: "",
      rules: { title: "Affiliate", required: true },
    },
    product: {
      name: "Product",
      value: [],
      rules: { title: "Product", required: true },
      error: "",
    },
  };
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  const [fields, setFields] = useState(editProductFields);
  const [affiliateOptions, setAffiliateOptions] = useState([]);
  const [productList, setProductList] = useState([]);
  const [productDropdown, setProductDropdown] = useState([]);
  const [allProductsChecked, setAllProductsChecked] = useState(false);
  const [isProductEmpty, setIsProductEmpty] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [dataList, setDataList] = useState({ local: {}, master: [] });

  const [isVisbile, setIsVisible] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(true);

  const [isPreData, setIsPreData] = useState(false);
  const [shouldSearchNow, setShouldSearchNow] = useState(false);

  const validate = useCallback(
    (e, field) => {
      const inputValue = e.target.value.toLowerCase();
      const ref_Data = props.referenceData.find(function (category) {
        return category.type === REF_DATA;
      }).referenceData;
      const regex = getApplicationRegex(ref_Data);
  
      if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
        // HTML Tags and Script detected, prevent it from being added
        showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
        showNotification(
          "Error!",
          "Validation configuration is missing. Please contact support.",
          "error"
        );
        return;
      }
      const validateFields = validateField(e, field, fields);
      setFields({ ...validateFields });
    },
    [fields]
  );

  const validateProduct = () => {
    const isProductEmpty = !allProductsChecked && productDropdown.length === 0;

    setFields((prevFields) => ({
      ...prevFields,
      product: {
        ...prevFields.product,
        error: isProductEmpty ? "Product List cannot be empty!!" : "",
      },
    }));
    setIsProductEmpty(isProductEmpty);
    return isProductEmpty;
  };

  useEffect(() => {
    const countryList = props.referenceData.filter(
      (item) => item.type === COUNTRIES
    )[0].countries;
    const affiliateList = countryList
      .map((c) => c.affiliate)
      .filter(onlyUnique)
      .sort();
    const options = affiliateList.map((affiliate) => ({
      value: affiliate,
      label: affiliate,
    }));
    setAffiliateOptions(options);

    // Query params
    const searchParams = new URLSearchParams(props.location.search);
    const queryAffiliate = searchParams.get("affiliate");
    const queryProductCode = searchParams.get("productCode");
    const queryName = searchParams.get("name");
    if (queryAffiliate && queryProductCode && queryName) {
      const affiliateExists = options.some(
        (option) => option.value === queryAffiliate
      );
      if (affiliateExists) {
        handleAffiliateChange(queryAffiliate, queryProductCode, queryName);
      }
    }
  }, [props.referenceData, props.location.search]);

  // When user selects affiliate OR query params, load products for affiliate
  const handleAffiliateChange = (
    affiliate = null,
    productCode = null,
    productName = null
  ) => {
    setDataList({ local: {}, master: [] });
    setIsVisible(false);
    setIsSearchActive(true);
    setFields((prevFields) => ({
      ...prevFields,
      affiliate: {
        ...prevFields.affiliate,
        value: affiliate ? affiliate : "",
      },
      product: {
        ...prevFields.product,
        value: [],
        error: "",
      },
    }));
    if (productCode === null && productName === null) {
      setProductDropdown([]);
    }
    setAllProductsChecked(false);
    setIsProductEmpty(false);

    if (affiliate) {
      const queryParams = {
        affiliate: affiliate,
      };
      api.admin.indication.getProductIndicationMasterList(
        queryParams,
        (productIndicationMaster) => {
          let productOptions = productIndicationMaster.PRODUCT_MASTER.filter(
            (product) => product.productCode.length === 4
          ).map((product) => ({
            value: product.productCode,
            label: product.name,
          }));
          setProductList(productOptions);
          if (productCode !== null && productName !== null) {
            const productExist = productOptions.find(
              (p) => p.value === productCode && p.label === productName
            );
            if (productExist) {
              const productObject = {
                value: productCode,
                label: productName,
              };
              handleProductChange([productObject], affiliate);
            }
          }
        },
        () => {
          showNotification(
            "Error",
            "There seems to be some error while fetching data for selected affiliate.",
            "error"
          );
          setProductList([]);
        }
      );
    }
  };

  const resetState = () => {
    setFields((prevFields) => ({
      ...prevFields,
      product: {
        ...prevFields.product,
        value: [],
        error: "",
      },
    }));
    setProductList([]);
    setProductDropdown([]);
    setAllProductsChecked(false);
    setIsProductEmpty(false);
  };

  const internalSearch = () => {
    const productValues = allProductsChecked ? productList : productDropdown;
    const payload = {
      affiliate: fields.affiliate.value,
      products: productValues.map(({ value, label }) => ({
        name: label,
        productCode: value,
      })),
    };
    setIsSearching(true);
    api_v2.getMasterAndLocalProducts(payload, (res) => {
      const cleanedLocal = Object.fromEntries(
        Object.entries(res.local).map(([country, products]) => [
          country,
          products.filter((product) => product !== null),
        ])
      );
      setDataList({
        local: cleanedLocal,
        master: res.master,
      });
      setIsSearching(false);
      setIsVisible(true);
      setIsSearchActive(false);
    });
  };

  //button search
  const onClickSearch = () => {
    setIsPreData(false);
    setShouldSearchNow(true);
  };

  const handleProductChange = (selected = null, affiliate = null) => {
    setDataList({ local: {}, master: [] });
    setIsVisible(false);
    setIsSearchActive(true);
    setProductDropdown(selected || []);
    setFields((prevFields) => ({
      ...prevFields,
      product: {
        ...prevFields.product,
        value: selected ? selected.map((option) => option.value) : [],
      },
    }));
    if (affiliate !== null) {
      setIsPreData(true);
    }
  };

  //controls the entire search process
  useEffect(() => {
    if (shouldSearchNow) {
      if (!validateProduct()) {
        internalSearch();
      }
      setShouldSearchNow(false);
    }
  }, [shouldSearchNow, fields, productDropdown, allProductsChecked]);

  // query params search
  useEffect(() => {
    if (isPreData) {
      setShouldSearchNow(true);
      setIsPreData(false);
    }
  }, [isPreData, fields, productDropdown, allProductsChecked]);

  return (
    <div className="v2_container">
      <div className="row">
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">
                Edit Product Name and Visibility for Countries
              </h3>
            </div>
          </div>
          <div>
            <div className="row md-4">
              <div className="col-md-4">
                <p>Select the affiliate to see the products.</p>
              </div>
            </div>
            <div className="row md-4">
              <div className="col-md-4">
                <Select
                  searchable
                  clearable={false}
                  options={affiliateOptions}
                  field={fields.affiliate}
                  validate={(e) => validate(e, fields.affiliate)}
                  onChange={(selected) => handleAffiliateChange(selected)}
                />
              </div>
            </div>
            <br />
            {productList.length > 0 && (
              <div className="row md-1">
                <div className="col-md-4" style={{ marginTop: "20px" }}>
                  <label className="custom-control custom-checkbox mr-0">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      checked={allProductsChecked}
                      onChange={() => {
                        setAllProductsChecked((prev) => !prev);
                        setIsVisible(false);
                        setDataList({ local: {}, master: [] });
                      }}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">
                      All Products
                    </span>
                  </label>
                </div>
              </div>
            )}
            {(productList.length === 0 || !allProductsChecked) && (
              <div>
                <div className="row md-4">
                  <div className="col-md-4" style={{ marginTop: "5px" }}>
                    <ReactSelect
                      multi
                      searchable={true}
                      clearable={false}
                      options={productList}
                      value={productDropdown}
                      onChange={handleProductChange}
                      placeholder="Select Products..."
                    />
                  </div>
                </div>
                {isProductEmpty && (
                  <div className="row md-1">
                    <div
                      className="col-md-4"
                      style={{
                        color: "red",
                        fontWeight: "bold",
                        marginTop: "10px",
                      }}
                    >
                      {fields.product.error}
                    </div>
                  </div>
                )}
              </div>
            )}
            <div className="row">
              <div className="col form-group text-left">
                <button
                  onClick={onClickSearch}
                  className="btn btn-lg btn-info btn-rounded"
                  style={{ marginTop: "10px" }}
                  disabled={!allProductsChecked && productDropdown.length === 0}
                >
                  {isSearching ? (
                    <div className="loading-text-centered">
                      <span>Search</span>
                      <span className="loading-progress-centered">
                        <CircularProgress size={24} />
                      </span>
                    </div>
                  ) : (
                    <React.Fragment>Search</React.Fragment>
                  )}
                </button>
              </div>
            </div>
          </div>
          {isVisbile && (
            <div style={{ marginBottom: "10px" }}>
              <strong>
                Note:- To enable the checkbox for a product, please provide a
                value for the local name. Without a value, the checkbox will
                remain inactive.
              </strong>
            </div>
          )}
          <div>
            {dataList && (
              <EditProductTable data={dataList} notify={showNotification} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default withRouter(connect(mapStateToProps, { notify })(EditProduct));



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Product_Mangement/EditProduct.js